/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { createContext, useContext } from 'react';
import useAEAHistory from '../common/hooks/useAEAHistory';

type AEAHistoryContextType = {
  AEAHistory: AEAHistoryResultObj;
  AEAHistoryErrors: string;
  getAEAHistory: (occur: number) => Promise<AEAHistoryResultObj>;
  AEAHistoryLoading: boolean;
};

const AEAHistoryContext = createContext<AEAHistoryContextType>({
  //showEscrowMonthsTable: false,
  AEAHistory: null,
  AEAHistoryErrors: '',
  getAEAHistory: (occur: number) => null,
  AEAHistoryLoading: false,
});

const useAEAHistoryContext = () => {
  const aeaHistoryContext = useContext(AEAHistoryContext);
  if (aeaHistoryContext === undefined) {
    /// throwing this error helps in development when the context is out of scope.
    throw new Error('AEAHistoryContext must be inside a AEAHistoryProvider');
  }
  return aeaHistoryContext;
};

const AEAHistoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { AEAHistory, getAEAHistory, AEAHistoryLoading, AEAHistoryErrors } = useAEAHistory();

  return (
    <AEAHistoryContext.Provider
      value={{
        AEAHistory,
        AEAHistoryErrors,
        getAEAHistory,
        AEAHistoryLoading,
      }}
    >
      {children}
    </AEAHistoryContext.Provider>
  );
};

export { AEAHistoryProvider, useAEAHistoryContext };
